
import BasicState from "src/libs/basic-view" 
import "../assets/css/style.scss"  
import TestsForm from "./tests/TestsForm"

export default class TestsView extends BasicState {
    props: any
    setIsLogged = ( bool:Boolean) => {
        this.setState({
            islogged : bool
        })
    } 
    addRender = () => {
        return <TestsForm {...this.props} setIsLogged={this.setIsLogged} />   
    }
}